"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateDisputeDto = void 0;
class CreateDisputeDto {
    projectMilestoneId;
    disputeType;
    describeIssue;
    expectation;
}
exports.CreateDisputeDto = CreateDisputeDto;
